(function () {
  const pattern = /\bblis[ \-‑–]?top\b/gi;
  const normalize = (value) => value.replace(pattern, 'BLIS-TOP');
  const skipped = new Set(['SCRIPT', 'STYLE', 'TEMPLATE', 'NOSCRIPT']);
  const attributes = ['alt', 'aria-label', 'title', 'placeholder'];

  function normalizeElement(root) {
    if (!(root instanceof Element) || skipped.has(root.tagName)) return;

    for (const attribute of attributes) {
      const value = root.getAttribute(attribute);
      if (value && pattern.test(value)) root.setAttribute(attribute, normalize(value));
      pattern.lastIndex = 0;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (skipped.has(node.parentElement?.tagName)) continue;
      if (pattern.test(node.nodeValue)) node.nodeValue = normalize(node.nodeValue);
      pattern.lastIndex = 0;
    }
  }

  function normalizeMetadata() {
    document.title = normalize(document.title);
    document.querySelectorAll('meta[content]').forEach((meta) => {
      const value = meta.getAttribute('content');
      if (value && pattern.test(value)) meta.setAttribute('content', normalize(value));
      pattern.lastIndex = 0;
    });
  }

  normalizeElement(document.body);
  normalizeMetadata();

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) normalizeElement(node);
        if (node.nodeType === Node.TEXT_NODE && !skipped.has(node.parentElement?.tagName)) {
          node.nodeValue = normalize(node.nodeValue);
        }
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
